import { render, staticRenderFns } from "./ConfigManager.vue?vue&type=template&id=87043826&scoped=true&"
import script from "./ConfigManager.vue?vue&type=script&lang=js&"
export * from "./ConfigManager.vue?vue&type=script&lang=js&"
import style0 from "./ConfigManager.vue?vue&type=style&index=0&id=87043826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87043826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87043826')) {
      api.createRecord('87043826', component.options)
    } else {
      api.reload('87043826', component.options)
    }
    module.hot.accept("./ConfigManager.vue?vue&type=template&id=87043826&scoped=true&", function () {
      api.rerender('87043826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/settings/ConfigManager.vue"
export default component.exports